import React from "react";
import { formatDate } from "../Utility/Helpers/sitewide";

export const Store = React.createContext("");

const initialState = {
  data_query: {
    perpage: 20,
    sort: "",
    from: 0,
    type: "active",
    parentic: "all",
    primaryic: "all",
    activitycodes: "all",
    doctype: "all",
    parentfoa: "all",
    daterange: "01011991-" + formatDate(new Date()),
    clinicaltrials: "all",
    fields: "all",
    apptype: "all",
    spons: true,
    query: "",
    noticeSubject: "all",
    researchInitiative: "all"
  },
  aggs_query: {
    type: "active",
    parentic: "all",
    primaryic: "all",
    activitycodes: "all",
    doctype: "all",
    parentfoa: "all",
    apptype: "all",
    noticeSubject: "all",
    daterange: "01011991-" + formatDate(new Date()),
    clinicaltrials: "all",
    query: "",
  },
  result: [],
  total_result: 0,
  aggs: {},
  funding_instrument: [],
  funding_category: [],
  funding_sub_category: [],
  pdpi_citizens: [],
  career_stage: [],
  mentored: [],
  activity_codes: [],
  reference_letters: [],
  custom_ac: {
    activity_code: "",
    funding_instrument: "",
    funding_category: "",
    funding_sub_category_rtcd: "",
    funding_sub_category_rd: "",
    funding_sub_category_sb: "",
    pdpi_citizens: "",
    career_stage: "",
    mentored: "",
    reference_letters: "",
  },
  fetched_options: {
    funding_category: [],
    funding_instrument: [],
    funding_sub_category: {
      rtcd: [],
      rd: [],
      sb: []
    },
  },
  default_orgs: [],
  default_acs: [],
  session: {
    id : '',
    actions: []
  }
};

function reducer(state, action) {
  switch (action.type) {
    case "SET_DATA_QUERY":
      state.data_query = action.payload;
      return { ...state };
    case "SET_AGGS_QUERY":
      state.aggs_query = action.payload;
      return { ...state };
    case "SET_RESULT":
      state.result = action.payload;
      state.total_result = action.payload.data.hits.total;
      return { ...state };
    case "SET_AGGS":
      state.aggs = action.payload;
      return { ...state };
    case "SET_FUNDING_INSTRUMENT":
      state.funding_instrument = action.payload;
      let funding_instrument = [];
      action.payload.map((item) => {
        funding_instrument.push({
          value: item.funding_instrument,
          label: item.funding_instrument,
        });
      });
      state.fetched_options.funding_instrument = funding_instrument;
      return { ...state };
    case "SET_FUNDING_CATEGORY":
      state.funding_category = action.payload;
      let funding_category = [];
      action.payload.map((item) => {
        funding_category.push({
          value: item.proposed_funding_category,
          label: item.proposed_funding_category,
        });
      });
      state.fetched_options.funding_category = funding_category;
      return { ...state };
    case "SET_FUNDING_SUB_CATEGORY":
      state.funding_sub_category = action.payload;
      let funding_sub_category_rtcd = [];
      let funding_sub_category_rd = [];
      let funding_sub_category_sb = [];
      action.payload.map((item) => {
        switch (item.proposed_funding_category) {
          case "Research Training and Career Development":
            funding_sub_category_rtcd.push({
              value: item.proposed_sub_category,
              label: item.proposed_sub_category,
            });
            break;
          case "Research and Development":
            funding_sub_category_rd.push({
              value: item.proposed_sub_category,
              label: item.proposed_sub_category,
            });
            break;
          case "Small Business":
            funding_sub_category_sb.push({
              value: item.proposed_sub_category,
              label: item.proposed_sub_category,
            });
            break;
        }
      });
      state.fetched_options.funding_sub_category.rtcd = funding_sub_category_rtcd ;
      state.fetched_options.funding_sub_category.rd = funding_sub_category_rd ;
      state.fetched_options.funding_sub_category.sb = funding_sub_category_sb ;
      return { ...state };
    case "SET_PDPI":
      state.pdpi_citizens = action.payload;
      return { ...state };
    case "SET_CAREER_STAGE":
      state.career_stage = action.payload;
      return { ...state };
    case "SET_MENTORED":
      state.mentored = action.payload;
      return { ...state };
    case "SET_ACTIVITY_CODES":
      state.activity_codes = action.payload;
      return { ...state };
    case "SET_REFERENCE_LETTERS":
      state.reference_letters = action.payload;
      return { ...state };
    case "SET_FILTERS":
      state.data_query.from = action.payload.from;
      state.data_query.query = action.payload.query;
      state.aggs_query.query = action.payload.query;
      if (action.payload.perpage) {
        state.data_query.perpage = action.payload.perpage;
      }
      if (action.payload.sort) {
        state.data_query.sort = action.payload.sort;
      }
      if (action.payload.type) {
        state.data_query.type = action.payload.type;
        state.aggs_query.type = action.payload.type;
      }
      if (action.payload.parentic) {
        state.data_query.parentic = action.payload.parentic;
        state.aggs_query.parentic = action.payload.parentic;
      }
      if (action.payload.primaryic) {
        state.data_query.primaryic = action.payload.primaryic;
        state.aggs_query.primaryic = action.payload.primaryic;
      }
      if (action.payload.activitycodes) {
        state.data_query.activitycodes = action.payload.activitycodes;
        state.aggs_query.activitycodes = action.payload.activitycodes;
      }
      if (action.payload.apptype) {
        state.data_query.apptype = action.payload.apptype;
        state.aggs_query.apptype = action.payload.apptype;
      }
      if (action.payload.researchInitiative) {
        state.data_query.researchInitiative = action.payload.researchInitiative;
      }

      if (action.payload.doctype) {
        state.data_query.doctype = action.payload.doctype;
        state.aggs_query.doctype = action.payload.doctype;
      }
      if (action.payload.noticeSubject) {
        state.data_query.noticeSubject = action.payload.noticeSubject;
        state.aggs_query.noticeSubject = action.payload.noticeSubject;
      }
      if (action.payload.daterange) {
        state.data_query.daterange = action.payload.daterange;
        state.aggs_query.daterange = action.payload.daterange;
      }
      if (action.payload.clinicaltrials) {
        state.data_query.clinicaltrials = action.payload.clinicaltrials;
        state.aggs_query.clinicaltrials = action.payload.clinicaltrials;
      }
      if (action.payload.parentfoa) {
        state.data_query.parentfoa = action.payload.parentfoa;
        state.aggs_query.parentfoa = action.payload.parentfoa;
      }

      if (action.payload.spons !== undefined) {
        state.data_query.spons = action.payload.spons;
      }

      if (action.payload.fields) {
        state.data_query.fields = action.payload.fields;
      }

      return { ...state };
    case "SET_CUSTOM_AC":
      if (action.payload.funding_instrument) {
        state.custom_ac.funding_instrument = action.payload.funding_instrument;
      }
      if (action.payload.funding_category) {
        state.custom_ac.funding_category = action.payload.funding_category;
      }
      if (action.payload.funding_sub_category_rtcd) {
        if(action.payload.funding_sub_category_rtcd === "all"){
          state.custom_ac.funding_sub_category_rtcd = "";
        } else {
          state.custom_ac.funding_sub_category_rtcd = action.payload.funding_sub_category_rtcd;
        }
      }

      if (action.payload.funding_sub_category_rd) {
        if(action.payload.funding_sub_category_rd === "all"){
          state.custom_ac.funding_sub_category_rd = "";
        } else {
          state.custom_ac.funding_sub_category_rd = action.payload.funding_sub_category_rd;
        }
      }

      if (action.payload.funding_sub_category_sb) {
        if(action.payload.funding_sub_category_sb === "all"){
          state.custom_ac.funding_sub_category_sb = "";
        } else {
          state.custom_ac.funding_sub_category_sb = action.payload.funding_sub_category_sb;
        }
      }
      
      if (action.payload.pdpi_citizens) {
        state.custom_ac.pdpi_citizens = action.payload.pdpi_citizens;
      }
      if (action.payload.career_stage) {
        state.custom_ac.career_stage = action.payload.career_stage;
      }
      if (action.payload.mentored) {
        state.custom_ac.mentored = action.payload.mentored;
      }
      if (action.payload.reference_letters) {
        state.custom_ac.reference_letters = action.payload.reference_letters;
      }
      if (action.payload.activity_code) {
        state.custom_ac.activity_code = action.payload.activity_code;
      }
      return { ...state };
    case "SET_DEFAULT_AGGS":
      if(action.payload.data && action.payload.data.aggregations && action.payload.data.aggregations.orgs){
        state.default_orgs = action.payload.data.aggregations.orgs;
      }
      if(action.payload.data && action.payload.data.aggregations && action.payload.data.aggregations.ac){
        state.default_acs = action.payload.data.aggregations.ac;
      }
      return { ...state };
    case "CLEAR_CUSTOM_AC":
      state.custom_ac = {
        activity_code: "",
        funding_instrument: "",
        funding_category: "",
        pdpi_citizens: "",
        career_stage: "",
        mentored: "",
        reference_letters: "",
        funding_sub_category_rtcd: "",
        funding_sub_category_rd: "",
        funding_sub_category_sb: ""
      };
      return { ...state };
    case "CLEAR_FILTERS":
      state.data_query = {
        perpage: 20,
        sort: "reldate:desc",
        from: 0,
        type: "active,activenosis",
        parentic: "all",
        primaryic: "all",
        activitycodes: "all",
        doctype: "all",
        parentfoa: "all",
        daterange: "01011991-" + formatDate(new Date()),
        clinicaltrials: "all",
        fields: "all",
        apptype: "all",
        researchInitiative: "all",
        noticeSubject: "all",
        spons: true,
        query: "",
      };
      state.aggs_query = {
        type: "active,activenosis",
        parentic: "all",
        primaryic: "all",
        activitycodes: "all",
        doctype: "all",
        parentfoa: "all",
        daterange: "01011991-" + formatDate(new Date()),
        clinicaltrials: "all",
        noticeSubject: "all",
        apptype: "all",
        query: "",
      };
      state.custom_ac = {
        activity_code: "",
        funding_instrument: "",
        funding_category: "",
        pdpi_citizens: "",
        career_stage: "",
        mentored: "",
        reference_letters: "",
        funding_sub_category_rtcd: "",
        funding_sub_category_rd: "",
        funding_sub_category_sb: ""
      };
      return { ...state };
    default:
      return state;
  }
}

export function StoreProvider(props) {
  const [state, dispatch] = React.useReducer(reducer, initialState);
  const value = { state, dispatch };
  return <Store.Provider value={value}>{props.children}</Store.Provider>;
}
